import * as svg from "../../../assets/star-filled-icon.svg";

import {iconBuilder} from "./iconBuilder";

export const StarFilledIcon = iconBuilder(svg, "StarFilledIcon", "0 0 12 12");
